import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { CapabilitiesListComponent } from './capabilities-list/capabilities-list.component';
import { CapabilitiesDetailComponent } from './capabilities-detail/capabilities-detail.component';
import { CapabilitiesRoutingModule } from './capabilities-routing.module';
import { InputSwitchModule } from 'primeng/inputswitch';


import { CoreModule } from 'src/app/core/core.module';
@NgModule({ declarations: [
        CapabilitiesListComponent,
        CapabilitiesDetailComponent
    ], imports: [CoreModule,
        CommonModule,
        CardModule,
        ButtonModule,
        CheckboxModule,
        InputTextModule,
        PasswordModule,
        FormsModule,
        TableModule,
        CardModule,
        CapabilitiesRoutingModule,
        ReactiveFormsModule,
        InputTextModule,
        ConfirmDialogModule,
        InputSwitchModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CapabilitiesModule { }
